import React, { useEffect } from 'react'
import styled from './CalendarMorePopup.module.css'
import useEstimateStore from '../stores/estimate'
import { useNavigate } from 'react-router-dom'

//CalendarMorePopup
const CalendarMorePopup = (props:any) => {
    const navigate = useNavigate()
    const { popRef, coordinates ={top:0, left:0}, data=[], curTime} = props
    const dateFormat = (date:Date) => {
        const year = date.getFullYear()
        const month = date.getMonth() + 1
        const day = date.getDate()
        return `${year}년 ${month}월 ${day}일`
    }
    const EventItem = (props:any)=> {
        const { eventInfo } = props
        const { setEstimate, estimateList} = useEstimateStore()
        // 00:00
        const startHour = eventInfo.start?.getHours().toString().padStart(2,'0') + ":" + 
            eventInfo.start?.getMinutes().toString().padStart(2, '0')
        
        const handleEventClick = (e:any) => {
            e.stopPropagation()
            const esti = estimateList.find((item:any)=>item.id === eventInfo.extendedProps?.estID)
            setEstimate(esti ?? null)
            navigate('/note')
        }

        return (
            <div style={{ display: "flex", justifyContent: "space-between", width: "100%", cursor:"pointer", margin: "5px 0"}}
            onClick={handleEventClick}>
                <div style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", margin: "0 3px"}}>
                    <span className="circle" style={{
                        display: 'inline-block',
                        marginRight: '7px',
                        width: '11px',
                        height: '11px',
                        borderRadius: '8px',
                        background: '#51D7DF'
                    }}/>
                    {eventInfo?.title}
                </div>
                <div style={{ whiteSpace: "nowrap", margin: "0 3px"}}>
                    {startHour}
                </div>
            </div>

        )
    }

    return (
        <div className={styled.calendar_more_popup}
            ref={popRef}
            style={{ 
            top: `${coordinates.top}px`, 
            left: `${coordinates.left}px`}}>
            <p className={styled.tit}> {dateFormat(curTime)} </p>
            {
                data.map((data:any)=>{ return <EventItem eventInfo={data}/> })
            }
        </div>
    )
}

export default CalendarMorePopup